// extracted by mini-css-extract-plugin
export var desktopWrapper = "BulletsStatic-module--desktopWrapper--c90d4";
export var fadeInAnimation = "BulletsStatic-module--fadeInAnimation--d6a68";
export var layout = "BulletsStatic-module--layout--a8779";
export var mobileWrapper = "BulletsStatic-module--mobileWrapper--bcf46";
export var title = "BulletsStatic-module--title--9e0b1";